export interface Sessione {
  id?: number;
  name: string;
  description: string;
  repetitions: number,
  active_time: number,
  recovery_time: number,
  gravity_management_complexity: number,
  motor_coordination_complexity: number,
  cardiorespiratory_complexity: number,
  equipment: string,
  recommended_for: string,
  contraindicated_for: string,
  status: 'Draft' | 'Published' | string;
  activities: number[];
  updated_at: '',
};

export const SessioneVuoto: Sessione = {
  name: '',
  description: '',
  repetitions: 1,
  active_time: 0,
  recovery_time: 0,
  gravity_management_complexity: 0,
  motor_coordination_complexity: 0,
  cardiorespiratory_complexity: 0,
  equipment: '',
  recommended_for: '',
  contraindicated_for: '',
  status: 'Draft',
  activities: [],
  updated_at: '',
};


export const tooltipColumnIds = [
  'description',
  'recommended_for',
  'contraindicated_for',
  'equipment'
]